export const HEAD_FORM_NAME = 'head';
export const TABLE_FORM_NAME = 'table';


